import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Compass, ArrowUpRight } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

export default function NotFound() {
    return (
        <div data-testid="notfound-page" className="min-h-screen flex flex-col bg-white">
            <div className="bg-white border-b border-zinc-200">
                <Navbar tone="light" />
            </div>
            <section className="flex-1 flex items-center justify-center bg-gradient-to-b from-zinc-50 to-white">
                <div className="text-center max-w-md mx-auto px-6 py-20 relative">
                    <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_60%_at_50%_30%,rgba(37,99,235,0.10),transparent_70%)]" aria-hidden />
                    <div className="relative">
                        <div className="mx-auto h-20 w-20 rounded-2xl bg-white border border-zinc-200 shadow-sm flex items-center justify-center">
                            <Compass className="h-9 w-9 text-brand-primary animate-spin" style={{ animationDuration: "6s" }} />
                        </div>
                        <p className="mt-6 font-mono-pg text-sm text-brand-primary">404 · OFF-COURSE</p>
                        <h1 className="mt-3 font-display text-5xl font-bold tracking-tight text-zinc-900">
                            We can't find that page.
                        </h1>
                        <p className="mt-4 text-zinc-600">
                            The link might be old, or maybe we moved it. Let's get you back on the path.
                        </p>
                        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                            <Button asChild data-testid="404-home-btn" className="bg-brand-primary hover:bg-brand-hover text-white h-11 px-6">
                                <Link to="/">Back to home <ArrowUpRight className="ml-1 h-4 w-4" /></Link>
                            </Button>
                            <Button asChild variant="outline" data-testid="404-pricing-btn" className="h-11 px-6 border-zinc-300">
                                <Link to="/pricing">See pricing</Link>
                            </Button>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}
